<div class="container-fluid p-0 h-100 w-100" style="min-width: 600px;">
  <div class="d-flex align-items-center justify-content-between" style="margin: 0 20px;">
    <p>0</p>
    <p>{{maxValue}}</p>
  </div>
  <div class="outside-line d-flex align-items-center" style="margin: 0 20px">
    <div class="line position-relative" id="line" style="height: 32px;" #lineParent>
      <div class="fill" [id]="'fill-'+filler" *ngFor="let filler of [0,1,2,3]"></div>
      <div *ngFor="let handle of handles; index as indexOfHandle" cdkDrag [cdkDragData]="handle" class="handle"
        [id]="'handle'+indexOfHandle" cdkDragLockAxis="x" cdkDragBoundary=".outside-line" [cdkDragFreeDragPosition]="dragPositions[indexOfHandle]" #handleElement>
        <i class="fa-solid fa-angle-left fa-lg"></i>
        <div class="mx-2" *ngIf="showNumber[indexOfHandle]">{{indexOfHandle == 0 ? retroRangeValues?.bad?.to :
          indexOfHandle == 1 ? retroRangeValues?.regular?.to : retroRangeValues?.good?.to}}</div>
        <i class="fa-solid fa-angle-right fa-lg"></i>
      </div>
    </div>
  </div>
</div>